/**
 * Checks if the given path belongs to private or authentication subdomains.
 */
export const isPrivateOrAuthPath = (path) => {
  if (!path) return false;
  // Normalize the path by removing query params and hash
  const cleanPath = path.split('?')[0].split('#')[0];
  const normalizedPath = cleanPath.toLowerCase();

  return (
    normalizedPath === '/login' ||
    normalizedPath === '/register' ||
    normalizedPath === '/sign-up' ||
    normalizedPath.startsWith('/my-account') ||
    normalizedPath.startsWith('/admin') ||
    normalizedPath.startsWith('/unauthorized')
  );
};

/**
 * Returns absolute subdomain URL on production, or relative path on dev/localhost.
 */
export const getSubdomainUrl = (path) => {
  if (!path) return '';
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : '';

  // Only rewrite URLs if we are on the actual production domain
  if (!hostname.endsWith('topinteriorsindia.com')) {
    return path;
  }

  // If path is already an absolute URL, return it
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (isPrivateOrAuthPath(path)) {
    return `${protocol}//my-account.topinteriorsindia.com${port}${path}`;
  } else {
    return `${protocol}//vendor.topinteriorsindia.com${port}${path}`;
  }
};

/**
 * Checks if navigating to the given path requires changing subdomains.
 */
export const isCrossSubdomain = (path) => {
  if (!path) return false;
  const hostname = window.location.hostname;

  // Only rewrite URLs if we are on the actual production domain
  if (!hostname.endsWith('topinteriorsindia.com')) {
    return false;
  }

  // If it's already an absolute URL, check if it matches the current subdomain
  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const url = new URL(path);
      return url.hostname !== hostname;
    } catch (e) {
      return false;
    }
  }

  const targetIsPrivate = isPrivateOrAuthPath(path);
  const currentIsPrivate = hostname.startsWith('my-account.');

  return targetIsPrivate !== currentIsPrivate;
};
